import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap justify-center -m-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading3 = _resolveComponent("Heading3")!
  const _component_Heading4 = _resolveComponent("Heading4")!
  const _component_Skill = _resolveComponent("Skill")!

  return (_openBlock(), _createElementBlock("article", null, [
    _createVNode(_component_Heading3, {
      class: "my-8 md:text-center",
      animation: true
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.article.heading), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.article.subarticles, (subarticle) => {
        return (_openBlock(), _createElementBlock("div", {
          key: subarticle.subheading,
          class: "w-full md:w-1/2 lg:w-1/3"
        }, [
          _createElementVNode("article", {
            class: "m-6 invisible",
            ref_for: true,
            ref: "skills"
          }, [
            _createVNode(_component_Heading4, { class: "mb-6 md:text-center" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(subarticle.subheading), 1)
              ]),
              _: 2
            }, 1024),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subarticle.skills, (skill) => {
              return (_openBlock(), _createBlock(_component_Skill, {
                key: skill.name,
                class: "mb-5",
                skill: skill
              }, null, 8, ["skill"]))
            }), 128))
          ], 512)
        ]))
      }), 128))
    ])
  ]))
}